module.exports = __webpack_public_path__ + "static/media/HARTVIG SIGNATURE TURNTABLE.92218ac2.png";